import { Icon } from "@outschool/backpack";
import { faFacebookMessenger } from "@outschool/icons";
import { facebookGeneralSendUrl } from "@outschool/routes";
import React from "react";

import * as Env from "../../../shared/Env";
import { CircularShareButton } from "./CircularShareButton";

const FACEBOOK_APP_ID = Env.FACEBOOK_APP_ID;

type Props = Omit<
  React.ComponentPropsWithoutRef<typeof CircularShareButton>,
  "icon"
> & {
  url: string;
  children: React.ReactNode;
};

export function FacebookMessengerButton({ url, ...props }: Props) {
  return (
    <CircularShareButton
      icon={<Icon icon={faFacebookMessenger} />}
      href={facebookGeneralSendUrl(url, FACEBOOK_APP_ID)}
      {...props}
    />
  );
}
